var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup865White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.16,
    height: 30,
    viewBox: "0 0 38.16 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(474.586 -147.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M-373.618,233.065c4.245,0,8.489.019,12.734-.009a2.741,2.741,0,0,1,2.793,1.932,3.544,3.544,0,0,1,.127.9q.011,8.742,0,17.484a2.736,2.736,0,0,1-2.832,2.853c-2.182.011-4.364,0-6.547,0q-9.52,0-19.041,0a2.74,2.74,0,0,1-2.827-2.054,3.355,3.355,0,0,1-.1-.828q-.008-8.7,0-17.4a2.713,2.713,0,0,1,2.124-2.808,4.083,4.083,0,0,1,.911-.066Q-379.945,233.061-373.618,233.065Zm7.458,19.047a2.452,2.452,0,0,0-.994-1.607,15.768,15.768,0,0,0-2.085-1.041c-.615-.273-1.28-.443-1.879-.745a1.913,1.913,0,0,1-.627-2.089c.032-.067.125-.1.164-.169.316-.53.624-1.066.941-1.6a1.121,1.121,0,0,1,.254-.319,1.457,1.457,0,0,0,.363-1.6.7.7,0,0,1-.044-.66,4.342,4.342,0,0,0-.2-3.072,1.583,1.583,0,0,0-1.3-1.044.543.543,0,0,1-.3-.216,1.853,1.853,0,0,0-1.226-.755,3.485,3.485,0,0,0-3.167.916,4.261,4.261,0,0,0-.914,4.235.717.717,0,0,1,0,.464,1.405,1.405,0,0,0,.387,1.771.6.6,0,0,1,.152.208,6.036,6.036,0,0,0,.693,1.324,1.948,1.948,0,0,1,.452,1.361,1.311,1.311,0,0,1-.867,1.374c-.532.234-1.1.382-1.639.6a14.051,14.051,0,0,0-1.87.861,2.685,2.685,0,0,0-1.23,1.792Z",
    transform: "translate(-78.467 -78.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M-443.195,151.692h-.647q-11.813,0-23.627,0A2.865,2.865,0,0,0-470,152.855a3,3,0,0,0-.511,1.807q0,8.441,0,16.882v.511c-1.8.273-3.306-.036-3.933-1.816a2.762,2.762,0,0,1-.141-.9q-.012-9.479,0-18.957a2.737,2.737,0,0,1,2.7-2.782c.08,0,.16,0,.239,0q12.731,0,25.463,0a2.7,2.7,0,0,1,2.839,2.078A14.376,14.376,0,0,1-443.195,151.692Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup865White);
export default __webpack_public_path__ + "static/media/Group 865-white.da926388bbe1128aaedb51cb75606df0.svg";
export { ForwardRef as ReactComponent };